import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const InlineSpinnerContainer = styled.span`
    color: ${tokens.text.secondary};
`;

const SpinnerContainer = styled.div`
    color: ${tokens.text.secondary};
`;

export const defaultSpinnerSize: SizeProp = '2x';

// This references the default div element attributes, but narrows it down to a more specific set
export type SpinnerProps = {
    className?: string;
    size?: SizeProp;
    inline?: boolean;
};

export function Spinner({
    className,
    size = defaultSpinnerSize,
    inline = false,
}: SpinnerProps) {
    const Container = inline ? InlineSpinnerContainer : SpinnerContainer;

    return (
        <Container className={`${className ?? ''} text-center`} aria-label="Loading">
            <FontAwesomeIcon icon={faSync} spin size={size} />
        </Container>
    );
}
